import { he } from "date-fns/locale";
import { authFetch } from "../../../authFetch";

export const createAssignment = async (requestData) => {
  try {
    const response = await authFetch("assignment", {
      method: "POST",

      body: requestData,
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("Error creating assignment:", err.message);
  }
};

export const fetchAssignmentByUser = async (userId) => {
  console.log("userId22", userId);
  try {
    const response = await authFetch(`assignment/fetch-by-user/${userId}`);
    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching assignment by user:", err.message);
  }
};

export const EditAssignment = async (requestData) => {
  try {
    const response = await authFetch(`assignment/update-assignment`, {
      method: "POST",

      body: requestData,
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("Error creating assignment:", err.message);
  }
};

export const deleteAssignment = async ({ requestData, id }) => {
  try {
    const response = await authFetch(`assignment/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });
    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error deleting assignment:", err.message);
  }
};

export const getAssignmentSubmissions = async (requestData) => {
  try {
    const response = await authFetch(`route2.0/submitted-assignment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("Error  :", err.message);
  }
};



export const handleUpdateSubmittedAssignment = async (requestData) => {
  try {
    const response = await authFetch(`route2.0/update-submitted-assignment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });
    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error updating assignment:", err.message);
  }
}

 
